export default __webpack_public_path__ + "static/media/google-play-badge-HIN.e12e97f6.png";